import Icon from '../components/Icon.vue'

Icon.register({
  paste: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M128 184C128 153.1 153.1 128 184 128H320V56C320 42.7 309.3 32 296 32H215.4C204.3 12.9 183.6 0 160 0S115.7 12.9 104.6 32H24C10.7 32 0 42.7 0 56V392C0 405.3 10.7 416 24 416H128V184zM160 40C173.3 40 184 50.7 184 64S173.3 88 160 88 136 77.3 136 64 146.7 40 160 40zM344 288H448V488C448 501.3 437.3 512 424 512H184C170.7 512 160 501.3 160 488V184C160 170.7 170.7 160 184 160H320V264C320 277.2 330.8 288 344 288zM448 249.9V256H352V160H358.1A24-24 0 0 0 375 167L441 233A24-24 0 0 0 448 249.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paste.js
// module id = SCDz
// module chunks = 144